'use strict';

Object.defineProperty(exports, "__esModule", {
        value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AwaitingreviewController = function AwaitingreviewController($scope, DTOptionsBuilder, DTColumnBuilder, USER, Constants, CONST, materialButtons, datePicker, $rootScope, FunctionService) {
        _classCallCheck(this, AwaitingreviewController);

        this.datatableApi;
        this.user = USER;
        this.name = 'Queries Awaiting Clinician Review';
        this.episodeValue = '';
        this.locale = 'en-au';
        this.specialtyString = '';
        this.separationString = '';
        this.western = $rootScope.westernConfig;

        this.url = WEBSERVICEURL + '/dataagility/api/service.queryawaitingreview?removeCoding=1&';
        this.initUrl = this.url + 'startDate=' + moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L') + '&endDate=' + moment().locale(this.locale).subtract(1, 'days').format('L') + '&status=' + encodeURIComponent('3 - Ready for Clinician');

        FunctionService.getFunctions($rootScope.globals.currentUser.roleId).then(function (response) {
                $scope.vm.episodeValue = response.functionSettings.EpisodeValue.valueString;
                $scope.vm.specialtyString = response.functionSettings.SpecialtyString.valueString;
                $scope.vm.separationString = response.functionSettings.SeparationString.valueString;
        });

        materialButtons.render();

        materialButtons.processing();

        // This is needed to obtain the sum of datatable column values
        jQuery.fn.dataTable.Api.register('sum()', function () {
                return this.flatten().reduce(function (a, b) {
                        if (typeof a === 'string') {
                                a = a.replace(/[^\d.-]/g, '') * 1;
                        }
                        if (typeof b === 'string') {
                                b = b.replace(/[^\d.-]/g, '') * 1;
                        }

                        return a + b;
                }, 0);
        });

        $scope.initCallback = function (nRow, aData, iDisplayIndex, iDisplayIndexFull) {

                // Datatables has finished init
                // Initialise searching
                if ($scope.vm.datatableApi) return;

                $scope.vm.datatableApi = this.api();

                // Update column headers even when no data returned
                // if (!$scope.vm.western)
                setDtHeaders($scope.vm.datatableApi);

                // setup search filters
                search();

                // set the table to a fixed height, so it never collapsed up and down
                $('#auditTable').closest(".dataTables_scrollBody").height(300);
        };

        $scope.drawCallback = function (nRow) {

                // tell DataTables we're using Aussie-formatted dates for ordering
                $.fn.dataTable.moment('DD/MM/YYYY');
                $.fn.dataTable.moment('DD/MM/YYYY HH:mm');

                var table = $('#auditTable').DataTable();

                $('.reports__stats #total-queries').html('Total Queries: ' + table.data().count());

                if (!$scope.vm.western) $('.reports__stats #total-proj-wies').html('Total Projected ' + $scope.vm.episodeValue + ': ' + parseFloat(table.column(7).data().sum()).toFixed(4));
        };

        this.dtOptions = DTOptionsBuilder.newOptions().withOption('ajax', {
                headers: { Authorization: 'Bearer ' + $rootScope.globals.currentUser.token },
                url: $scope.vm.initUrl,
                type: 'GET',
                error: function error(xhr, _error, thrown) {
                        if (thrown == 'Unauthorized') {
                                //window.location.replace(window.location.origin + '/login');
                                console.log('Unauthorized request with token: ', $rootScope.globals.currentUser.token);
                        }
                }
        }).withDisplayLength(CONST.TABLEROWS).withDataProp('data').withOption('processing', true).withOption('sAjaxDataProp', '').withOption('bLengthChange', false).withPaginationType('simple_numbers').withOption('rowCallback', function (row, data, index) {
                // Update column headers if data returned
                if (!$scope.vm.western) setDtHeaders($('#auditTable').DataTable());
        }).withOption('drawCallback', $scope.drawCallback).withOption('initComplete', $scope.initCallback).withOption('scrollY', '300px').withOption('scrollX', 'auto').withOption('scrollX', 'auto').withOption('aaSorting', [[2, 'asc']]).withOption('dom', '<"wrapper"rt<"table-footer"iBp>>').withButtons([{
                extend: 'print',
                text: ''
        }, {
                extend: 'csvHtml5',
                text: '',
                filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
        }, {
                extend: 'excelHtml5',
                text: '',
                filename: $scope.vm.name + "-" + moment().format("YYYYMMDD-HHmm")
        }, {
                text: '',
                action: function action(e, dt, node, config) {
                        dt.ajax.reload();
                }
        }]).withColumnFilter({
                //sPlaceHolder: "head:after",
                aoColumns: [{ type: 'number' }, { type: "date-range" }, { type: "date-range" }, { type: "select" }, { type: "date-range" }]
        });

        function yesNo(data) {
                return data === true ? "Y" : "N";
        }

        this.dtColumns = [DTColumnBuilder.newColumn('urn').withTitle('UR Number').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('admissionDate').withTitle('Admission Date').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('dischargeDate').withTitle('Loading...').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('speciality').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('querySpecialty').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'), DTColumnBuilder.newColumn('modifiedDttm').withTitle('Ready for Clinician').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric').renderWith(function (data, type, full) {
                return moment(full.modifiedDttm).locale($scope.vm.locale).format('L');
        }), DTColumnBuilder.newColumn('currentDRG').withTitle('Current DRG').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric')];

        if (!$scope.vm.western) this.dtColumns.push(DTColumnBuilder.newColumn('projectedWIES').withTitle('Loading...').withOption('defaultContent', '').withClass('mdl-data-table__cell--non-numeric'));

        // Search filters
        this.specialty = {
                selectedSpecialty: []
        };
        this.specialtyOptions = {};

        this.querySpecialty = {
                selectedQuerySpecialty: []
        };

        Constants.getDivisionAndSpecialtyData().then(function successCallback(response) {
                $scope.vm.specialtyOptions = response.specialties;
                filterSpecialty($scope.vm.specialtyOptions);
        });

        this.startDatePicker = {
                input: {
                        date: moment().locale(this.locale).subtract(1, 'months').startOf('month'),
                        dateFormatted: moment().locale(this.locale).subtract(1, 'months').startOf('month').format('L')
                }
        };
        this.endDatePicker = {
                input: {
                        date: moment().locale(this.locale).subtract(1, 'days'),
                        dateFormatted: moment().locale(this.locale).subtract(1, 'days').format('L')
                }
        };

        // callbacks for lx-selects and lx-date-picker
        datePicker.autoClose($scope);
        this.filterCallback = filterCallback;

        function setDtHeaders(table) {
                $(table.column(2).header()).html($scope.vm.separationString + ' Date');
                $(table.column(3).header()).html($scope.vm.specialtyString);
                $(table.column(4).header()).html('Query ' + $scope.vm.specialtyString);

                if (!$scope.vm.western) {
                        $(table.column(7).header()).html('Projected ' + $scope.vm.episodeValue);
                }
        }

        function selectFilter(column, filter) {

                if (filter) {

                        filter = filter.join("|");

                        if (filter !== '') filter = '^' + filter + '$';

                        var auditTable = $scope.vm.datatableApi;

                        auditTable.columns(column).search(filter, true, false).draw();
                }
        }

        function filterCallback(_newValue, _oldValue) {
                $scope.vm.changeData();
        }

        function filterSpecialty(swap) {
                $scope.vm.specialty.selectedSpecialty = [];
                if (swap === 'add') {
                        $scope.vm.specialty.selectedSpecialty = $scope.vm.specialtyOptions;
                }
        }

        function filterQuerySpecialty(swap) {
                $scope.vm.querySpecialty.selectedQuerySpecialty = [];
                if (swap === 'add') {
                        $scope.vm.querySpecialty.selectedQuerySpecialty = $scope.vm.specialtyOptions;
                }
        }

        function setDefaultDate() {

                $scope.vm.startDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month');
                $scope.vm.startDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'months').startOf('month').format('L');

                $scope.vm.endDatePicker.input.date = moment().locale($scope.vm.locale).subtract(1, 'days');
                $scope.vm.endDatePicker.input.dateFormatted = moment().locale($scope.vm.locale).subtract(1, 'days').format('L');
        }

        function checkParam(param) {

                if (param.length !== 0) {

                        return encodeURIComponent(param.join());
                } else {

                        return "";
                }
        }

        this.changeData = changeData;

        function changeData() {

                var newUrl = $scope.vm.url + 'startDate=' + $scope.vm.startDatePicker.input.dateFormatted + '&endDate=' + $scope.vm.endDatePicker.input.dateFormatted + '&specialty=' + checkParam($scope.vm.specialty.selectedSpecialty) + '&querySpecialty=' + checkParam($scope.vm.querySpecialty.selectedQuerySpecialty) + '&status=' + encodeURIComponent('3 - Ready for Clinician');
                if ($scope.vm.datatableApi) {
                        $scope.vm.datatableApi.ajax.url(newUrl).load().draw();
                }
        }

        function search() {

                // delete any global searches previously applied
                if ($.fn.dataTable.ext.search.length === 1) $.fn.dataTable.ext.search.shift();

                var auditTable = $scope.vm.datatableApi;
                auditTable.search('').draw();

                filterSpecialty('minus');
                filterQuerySpecialty('minus');

                // re-draw tabele on datepicker close
                $scope.$on('lx-date-picker__close-start', function (e, id) {

                        $scope.vm.changeData();
                });
        }

        // bind the datatable instance to an object to monitor loading
        this.dtInstanceCallback = dtInstanceCallback;

        function dtInstanceCallback(dtInstance) {

                $scope.dtInstance = dtInstance._renderer;
        }

        // bind filter swap
        this.filterSwap = filterSwap;

        function filterSwap(thisFilter, thisModifier) {

                switch (thisFilter) {

                        case 'specialty':

                                if (thisModifier === 'add') {

                                        filterSpecialty('add');
                                } else {

                                        filterSpecialty('minus');
                                }

                                break;

                        case 'querySpecialty':

                                if (thisModifier === 'add') {

                                        filterQuerySpecialty('add');
                                } else {

                                        filterQuerySpecialty('minus');
                                }

                                break;

                        default:
                                break;
                }
        }
};

exports.default = AwaitingreviewController;


// WEBPACK FOOTER //
// ./client/app/common/reports/awaitingreview/awaitingreview.controller.js